import { createFileRoute } from '@tanstack/react-router';
import Threats from 'src/pages/Organization/Threats';

export const Route = createFileRoute('/$organizationSlug/mechanics/threats/$')({
  component: () => <Threats />,
});
